


























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";

const StopCollectionModal = () => import("./stopCollectionModal/index.vue");
const ReducePenalty = () => import("./orderDeal/components/reducePenalty.vue");
const ManualUpgradeTicketDialogue = () =>
  import("./ManualUpgradeTicketDialogue/index.vue");
import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetTicketListReq,
  BatchAssignTicketReq,
  BatchRecycleTicketReq,
  BatchEntrustTicketReq,
  BatchRecallTicketReq,
  RollApplyTicketReq,
  ReduceTicketReq,
  GetTicketListParamReq,
  CloseTicketReq,
  Bool,
  OpenTicketReq,
} from "@/pbjs/external/ticket/ticket_pb";
import { ExportTicketEmailCSVReq } from "@/pbjs/xcommon/ticket_pb";
import {
  ListUserGroupByTypeReq,
  ListUserGroupByMutiTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";

@Component({
  name: "CombinationProperty",
  components: {
    ReducePenalty,
    ManualUpgradeTicketDialogue,
    StopCollectionModal
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private formLabelWidth= '120px';
  @Provide() private resultData: any = [];
  @Provide() private userData: any = [];
  @Provide() private principalData: any = [];
  @Provide() private leftamount: any = null;
  @Provide() private penaltyData: any = [];
  @Provide() private token: any;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private XJoederid: number = 0;
  @Provide() private OnlineOrNotOptions: any = [
    { value: 1, name: "dashbordDy.yes" },
    { value: 2, name: "dashbordDy.no" },
  ];
  @Provide() private machineCollection: any = [
    { value: 1, name: "dashbordDy.yes" },
    { value: 2, name: "dashbordDy.no" },
  ];

  @Provide() private pagnition: any = pagnition;
  @Provide() private userPageIndex: number = 1;
  @Provide() private userPagerCount: number = 0;
  @Provide() private filterText: string = "";
  @Provide() private isShowNewLoadAttr: boolean = false;
  @Provide() private userId: string | null = "";
  @Provide() private loadTypeOptions: any = [
    { value: 1, name: "固定数值" },
    { value: 2, name: "公式" },
    { value: 3, name: "百分比" },
  ];

  @Provide() private RobotCallIntentTagMap: any = [];
  @Provide() private AppOpnList: any = [];
  @Provide() private AppName: any = "";
  @Provide() private inputExportEmail: any = ""; //导出邮箱

  @Provide() private formulaOptions: any = [];
  @Provide() private isEdit: boolean = false;
  @Provide() private onEditRow: any = {};
  @Provide() private showDialogType: number = 0;
  @Provide() private ticketSelection: any = [];
  @Provide() private selectedTicketIds: number[] = [];
  @Provide() private selectedAssignUser: any;
  @Provide() private roleOptions: any = [];
  @Provide() private isEditTicketId: number = 0;
  @Provide() private ticketStatusOptions: any = [];
  @Provide() private ticketTypeOptions: any = [];
  @Provide() private searchUserIds: any = [];
  @Provide() private userForm: any = {
    email: "",
    name: "",
    role: "",
    radio: "",
  };
  @Provide() private ruleForm: any = {
    itemId: null,
    ticketId: null,
    orderId: null,
    customerId: null,
    caseId: null,
    createTimeRange: [],
    completeTimeRange: [],
    closeTimeRange: [],
    assignTimeRange: [],
    status: "",
    overdueDays1: "",
    overdueDays2: "",
    assignName: "",
    UrgeResult: "",
    assignUId: null,
    attrIds: [],
    isReloan: null,
    outsource: null,
    belongCompany: null,
    roleList: null,
    isRoll: null,
    isStage: null,
    TicketTag: null,
    overdueReason: [],
    preStatus: [],
    machineCollection: null,
    RobotCallIntentTag: null,
    pageSize: null,
    mobile: "",
  };
  @Provide() private principalForm: any = {
    principal: null,
    reason: "",
  };
  @Provide() private dialogVisible: any = false;
  @Provide() private ticketData: any = {};
  @Provide() private penaltyForm: any = {
    interest: null,
    penalty: null,
    reason: "",
  };
  @Provide() private rules: any = {};
  @Provide() private reloanOptions: any = [
    { name: "v0707.FirstLoan", value: Bool.BOOL_NO },
    { name: "v0707.Reloan", value: Bool.BOOL_YES },
  ];
  @Provide() private UrgeResultOptions: any = [];
  @Provide() private TicketTagMapOptions: any = [];
  @Provide() private preStatusOptions: any = [];
  @Provide() private dialogFormEmailVisible: boolean = false;
  @Provide() private isGetTicketListActionDone: boolean = false;
  @Provide() private isGetExportTicketEmailCSVDone: boolean = false;
  @Provide() private isShowManualUpgradeTicketDialogue: boolean = false;
  @Provide() private isGetTicketListExcelActionDone: boolean = false;
  @Provide() private system: any = localStorage.getItem("systemInfo");
  @Provide() private amountremained: any = "";
  @Provide() private isUseAmountRemained: boolean = false;
  @Provide() private isGetManualUpgradeTicketActionDone: boolean = false;
  @Provide() private OverdueDay: string = "";
  @Provide() private isSearchUserActionDone: boolean = false;
  @Provide() private companyOptions: any = [];
  @Provide() private companyValue: number | null = null;
  @Provide() private isSelectedIdSearch: boolean = false;
  @Provide() private outsourceOptions: any = [
    { name: "normal", value: Bool.BOOL_NO },
    { name: "outsourcing", value: Bool.BOOL_YES },
  ];
  @Provide() private belongCompanyOptions: any = [];
  @Provide() private sortCondition: any = {
    prop: null,
    order: null,
  };
  @Provide() private isEditRow: any = {};
  @Provide() private country: any = localStorage.getItem("country");
  @Provide() private isShowSearchRegion: boolean = true;
  @Provide() private rollOptions: any = [
    { name: "Normal Ticket", value: Bool.BOOL_NO },
    { name: "Extension Ticket", value: Bool.BOOL_YES },
  ];

  @Provide() private StageOptions: any = [
    { name: "Single payment", value: Bool.BOOL_NO },
    { name: "Partial payment", value: Bool.BOOL_YES },
  ];
  @Provide() private overdueReasonOptions: any = [];
  private created() {
    this.token = localStorage.getItem("token");
    this.userId = localStorage.getItem("userid");
    this.getTicketListParam();
    this.getRoleListAPI();
  }

  @Provide() private showTimesTips: any = {
    showlefttotaltips: null,
    lefttotalgroup: "",
    lefttotalstaff: "",
    showleftapplyamounttips: "",
    leftapplyamount: "",
  };

  @Provide() private principalDone: Boolean = false;
  @Provide() private popVisible: Boolean = false;
  @Provide() private stopRowData: any = {};
  @Provide() private stopType: any = {};


  private changePage(e) {
    this.pageSize = e
    this.handleSizeChange(e || 20)
  }
  private showPopDialog(type:boolean, data?:any, stopType?:string) {
    this.popVisible = type;
    if(data) {
      this.stopRowData = data;
    }
    if(stopType) {
      this.stopType = stopType;
    }
  }
  private showDiffTypeDialog(type: number) {
    this.showDialogType = type;
  }
  private hideManualUpgradeTicketDialogue(val: any) {
    this.isShowManualUpgradeTicketDialogue = false;
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    this.getTicketList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    this.getTicketList();
  }

  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      this.getTicketList();
    }
  }
  private handleNextChange(val: any) {
    this.getTicketList();
  }
  private getTicketListAction() {
    this.isGetTicketListActionDone = true;
    this.pageIndex = 1;
    this.getTicketList();
  }
  private getTicketListExcelAction() {
    this.isGetTicketListExcelActionDone = true;
    this.getTicketListExcel();
  }
  private getExportTicketEmailCSVAction() {
    // 先校验条件，通过后才弹出邮箱弹窗
    if (!this.limitTimeRange()) {
      return;
    }
    if (!this.dwGetExportTicketEmailCSVNeed()) {
      return;
    }
    // 校验通过，弹出邮箱输入弹窗
    this.inputExportEmail = "";
    this.dialogFormEmailVisible = true;
  }
  private onEmailConfirm() {
    // 校验邮箱必填
    if (!this.inputExportEmail || !this.inputExportEmail.trim()) {
      this.$message.error("邮箱不能为空");
      return;
    }

    // 校验邮箱格式
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.inputExportEmail.trim())) {
      this.$message.error("请输入正确的邮箱格式");
      return;
    }

    // 校验通过，关闭弹窗并开始导出
    this.dialogFormEmailVisible = false;
    this.isGetExportTicketEmailCSVDone = true;
    this.getExportTicketEmailCSV();
  }
  private showManualUpgradeTicketDialogue() {
    this.isShowManualUpgradeTicketDialogue = true;
  }
  private handleAssignCurrentChange(val: any) {
    this.userPageIndex = Number(val);
    this.searchUser();
  }

  private handleAssignPrevChange(val: any) {
    if (this.userPageIndex > 0) {
      this.searchUser();
    }
  }

  private handleAssignNextChange(val: any) {
    this.searchUser();
  }

  private handleAssignSizeChange(val: any) {
    this.pageSize = Number(val);
    this.searchUser();
  }

  private searchUserAction() {
    this.isSearchUserActionDone = true;
    this.userPageIndex = 1;
    this.searchUser();
  }

  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
    this.AppName = ''
  }

  private showOrHideSearchRegion() {
    this.isShowSearchRegion = !this.isShowSearchRegion;
  }

  private sortChange(val: any) {
    switch (val.prop) {
      case "handlenum":
        this.sortCondition.prop = Sort.SORT_BY_HANDLE_NUM;
        break;
      case "lasthandletime":
        this.sortCondition.prop = Sort.SORT_BY_LAST_HANDLE_TIME;
        break;
      case "partialcompletetime":
        this.sortCondition.prop = Sort.SORT_BY_PARTIAL_COMPLETE_TIME;
        break;
      case "nexthandletime":
        this.sortCondition.prop = Sort.SORT_BY_PROMISE_REPAY_TIME;
        break;
      case "completetime":
        this.sortCondition.prop = Sort.SORT_BY_COMPLETE_TIME;
        break;
      case "overdueday":
        this.sortCondition.prop = Sort.SORT_BY_OVERDUE_DAY;
        break;
      case "remainamount":
        this.sortCondition.prop = Sort.SORT_BY_REMAIN_AMOUNT;
        break;
      default:
        this.sortCondition.prop = Sort.SORT_UNSPECIFIED;
        break;
    }
    switch (val.order) {
      case "descending":
        this.sortCondition.order = Rank.RANK_DESC;
        break;
      case "ascending":
        this.sortCondition.order = Rank.RANK_ASC;
        break;
      default:
        this.sortCondition.order = Rank.RANK_UNSPECIFIED;
        break;
    }
    this.getTicketListAction();
  }

  private massAssign() {
    if (this.isSelectedIdSearch) {
      this.showDialogType = 1;
      this.searchUser();
    } else {
      this.$message.error("Please choose the order classify");
    }
  }

  private confirmMassAssign() {
    this.findSelectedIds();
    this.batchAssignTicket();
  }

  private massRecyle() {
    if (this.isSelectedIdSearch) {
      this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
        confirmButtonText: this.$tc("authority.ok"),
        cancelButtonText: this.$tc("authority.cancel"),
        type: "warning",
      })
        .then(() => {
          this.findSelectedIds();
          this.batchRecycleTicket();
        })
        .catch(() => {});
    } else {
      this.$message.error("Pls choose the order classify");
    }
  }

  private massOutsource() {
    if (this.isSelectedIdSearch) {
      this.getOutSourceInfo();
      this.showDialogType = 4;
    } else {
      this.$message.error("Pls choose the order classify");
    }
  }

  private doMassOutsource() {
    this.findSelectedIds();
    this.batchEntrustTicket();
  }

  private massRecall() {
    if (this.isSelectedIdSearch) {
      this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
        confirmButtonText: this.$tc("authority.ok"),
        cancelButtonText: this.$tc("authority.cancel"),
        type: "warning",
      })
        .then(() => {
          this.findSelectedIds();
          this.batchReccallTicket();
        })
        .catch(() => {});
    } else {
      this.$message.error("Pls choose the order classify");
    }
  }

  private applyRenewal(row: any) {
    this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
      confirmButtonText: this.$tc("authority.ok"),
      cancelButtonText: this.$tc("authority.cancel"),
      type: "warning",
    }).then(() => {
      this.rollApplyTicket();
    });
  }
  private dialogVisibleOpen(row: any) {
    let request: any = new OpenTicketReq();
    request.setCommonin(setCommon());
    request.setTicketid(Number(row.id));
    request.setItemid(Number(row.itemid));
    ticketClient.openTicket(request, {}, (err: any, response: any) => {
      if (response) {
        this.dialogVisible = false;
        let data: any = response.toObject();
        let _fuc = this.doCloseTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
      }
    });
  }
  private principalReduction(row: any) {
    this.isEditRow = row;
    this.showDialogType = 2;
    this.isEditTicketId = row.id;
    this.reduceTicket(row);
  }
  private confirmPrincipalReduction() {
    this.doReducePrincipal();
  }

  private principalChange(e: any) {
    this.principalForm.principal = e;
  }

  private penaltyReduction(row: any) {
    this.isEditRow = row;
    this.showDialogType = 3;
    this.isEditTicketId = row.id;
    this.ticketData = row;
  }

  private handleSelectionChange(val: any) {
    this.ticketSelection = val;
  }

  private handleRoleChange(val: any) {
    this.selectedAssignUser = val;
  }

  private findSelectedIds() {
    this.selectedTicketIds = [];
    this.ticketSelection.forEach((item: any) => {
      this.selectedTicketIds.push(item.id);
    });
  }

  private closeDialog() {
    if (this.showDialogType === 2) {
      this.resetForm("principalForm");
    } else if (this.showDialogType === 3) {
      this.resetForm("penaltyForm");
    }
    this.showDialogType = 0;
  }

  private goCollectionDetailPage(row: any) {
    let routeData: any = this.$router.resolve({
      path: "collectionDetail",
      query: {
        id: row.relatedid,
        type: row.casetype == 1 ? "repay" : "overdue",
        orderId: row.orderid,
      },
    });
    window.open(routeData.href, "_blank");
  }

  private goOrderLoggingPage(row: any) {
    let routeData: any = this.$router.resolve({
      path: "orderLogging",
      query: {
        itemId: row.itemid,
        ticketId: row.id,
      },
    });
    window.open(routeData.href, "_blank");
  }
  private openTicket(row: any) {
    this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
      confirmButtonText: this.$tc("authority.ok"),
      cancelButtonText: this.$tc("authority.cancel"),
      type: "warning",
    }).then(() => {
      this.dialogVisibleOpen(row);
    });
  }
  private closeTicket(row: any) {
    this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
      confirmButtonText: this.$tc("authority.ok"),
      cancelButtonText: this.$tc("authority.cancel"),
      type: "warning",
    }).then(() => {
      this.doCloseTicket(row);
    });
  }
  private doCloseTicketFuc(data: any) {
    this.$message({
      type: "success",
      message: "Success!",
    });
    this.getTicketList();
  }
  private doCloseTicket(row: any) {
    let request: any = new CloseTicketReq();
    request.setCommonin(setCommon());
    request.setTicketid(Number(row.id));
    request.setItemid(Number(row.itemid));
    ticketClient.closeTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.doCloseTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        if (err.code == 16) {
          this.$router.push("./login");
        } else {
          this.$message.error(err.errmsg || err.message);
        }
      }
    });
  }
  private getRoleListAPIFuc(data: any) {
    if (data.usergroupinfosList) {
      this.roleOptions = data.usergroupinfosList;
    }
  }
  private getRoleListAPI() {
    let arr: any = [
      ExecType.EXEC_TYPE_URGE_INTERNAL,
      ExecType.EXEC_TYPE_URGE_OUTSOURCE,
      ExecType.EXEC_TYPE_ROBOT,
    ];
    let request: any = new ListUserGroupByMutiTypeReq();
    request.setCommonin(setCommon());
    request.setExectypeList(arr);
    authorClient.listUserGroupByMutiType(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getRoleListAPIFuc;
          handleResponse(data, _fuc);
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
  private getOutSourceInfoFuc(data: any) {
    this.companyOptions = data.companyinfosList;
  }
  private getOutSourceInfo() {
    let request: any = new GetOutSourceInfoReq();
    request.setCommonin(setCommon());
    request.setExectype(2);
    client.getOutSourceInfo(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.getOutSourceInfoFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private batchGetLoginInfoFuc(data: any) {
    let map: any = new Map(data.logininfomapMap);
    this.userData.forEach((item: any) => {
      if (map.has(item.id) && map.get(item.id).status) {
        this.$set(item, "online", this.$t("v0707.Yes"));
      } else {
        this.$set(item, "online", this.$t("v0707.No"));
      }
    });
  }
  private batchGetLoginInfo() {
    let request: any = new BatchGetLoginInfoReq();
    request.setCommonin(setCommon());
    request.setUseridList(this.searchUserIds);
    client.batchGetLoginInfo(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchGetLoginInfoFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private getTicketListFuc(data: any) {
    this.pagerCount = data.pageout.total;
    this.resultData = [];
    data.listList.forEach((item: any, index: number) => {
      let _obj: any = {
        casename: item.casename,
        assignname: item.assignname,
        ticketstatus: item.ticketstatus,
        status: item.ticket.status,
        urgeresult: item.urgeresult,
        overduereason: item.overduereason,
        prestatus: item.prestatus,
        isnewticket: item?.isnewticket
      };
      let otherInfo: any = Object.assign({}, item);
      let ordertags = item.ordertags;
      let tickettags = item.tickettagsList;
      let casetype = item.casetype;
      item = item.ticket;
      item.ordertags = ordertags;
      item.tickettags = tickettags;
      item.casetype = casetype;
      item.ctime = item.ctime && timeFormat(item.ctime);
      item.assigntime = item.assigntime && timeFormat(item.assigntime);
      item.starttime = item.starttime && timeFormat(item.starttime);
      item.lasthandletime =
        item.lasthandletime && timeFormat(item.lasthandletime);
      item.nexthandletime =
        item.nexthandletime && timeFormat(item.nexthandletime);
      item.partialcompletetime =
        item.partialcompletetime && timeFormat(item.partialcompletetime);
      item.expiretime = item.expiretime && timeFormat(item.expiretime);
      item.closetime = item.closetime && timeFormat(item.closetime);
      item.completetime = item.completetime && timeFormat(item.completetime);
      item.isrobot =
        item.isrobot == 1
          ? this.$t("dashbordDy.yes")
          : item.isrobot == 2
          ? this.$t("dashbordDy.no")
          : "-";
      item.isreloan = item.isreloan
        ? this.$t("v0707.Reloan")
        : this.$t("v0707.FirstLoan");
      item.isstage =
        item.isstage == 0
          ? this.$t("Single payment")
          : this.$t("Partial payment");
      this.belongCompanyOptions.forEach((i: any) => {
        if (i.value == item.entrustcompany) {
          item.entrustcompanytext = i.name;
        }
      });

      item.isentrusttext = item.isentrust
        ? this.$t("Outsourcing")
        : this.$t("Local Collection");
      item.lasturgeremark = otherInfo.lasturgeremark;
      item.overdueday = otherInfo.overdueday;
      item.phoneobjectset = otherInfo.phoneobjectset;
      item.urgetypeset = otherInfo.urgetypeset;
      item.risklevel = otherInfo.risklevel;
      item.suspendtime = otherInfo.suspendtime;
      item.suspenduid = otherInfo.suspenduid;
      item.suspenduser = otherInfo.suspenduser;
      this.resultData[index] = item;
      Object.assign(this.resultData[index], _obj);
      this.isSelectedIdSearch = this.ruleForm.itemId ? true : false;
    });
  }
  private limitInOneMonth(obj: any, begin: any, end: any) {
    if (obj && begin) {
      if (
        new Date(begin).getTime() < new Date(end).getTime() &&
        new Date(end).getTime() <=
          new Date(begin).getTime() + 31 * 24 * 60 * 60 * 1000
      ) {
        return true;
      } else {
        this.$message.warning(
          "Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes"
        );
        return false;
      }
    } else {
      return true;
    }
  }
  private limitTimeRange() {
    if (
      (this.ruleForm.createTimeRange && this.ruleForm.createTimeRange[0]) ||
      (this.ruleForm.completeTimeRange && this.ruleForm.completeTimeRange[0]) ||
      (this.ruleForm.closeTimeRange && this.ruleForm.closeTimeRange[0]) ||
      (this.ruleForm.assignTimeRange && this.ruleForm.assignTimeRange[0])
    ) {
      if (
        this.limitInOneMonth(
          this.ruleForm.createTimeRange,
          this.ruleForm.createTimeRange
            ? this.ruleForm.createTimeRange[0]
            : false,
          this.ruleForm.createTimeRange
            ? this.ruleForm.createTimeRange[1]
            : false
        ) &&
        this.limitInOneMonth(
          this.ruleForm.completeTimeRange,
          this.ruleForm.completeTimeRange
            ? this.ruleForm.completeTimeRange[0]
            : false,
          this.ruleForm.completeTimeRange
            ? this.ruleForm.completeTimeRange[1]
            : false
        ) &&
        this.limitInOneMonth(
          this.ruleForm.closeTimeRange,
          this.ruleForm.closeTimeRange
            ? this.ruleForm.closeTimeRange[0]
            : false,
          this.ruleForm.closeTimeRange ? this.ruleForm.closeTimeRange[1] : false
        ) &&
        this.limitInOneMonth(
          this.ruleForm.assignTimeRange,
          this.ruleForm.assignTimeRange
            ? this.ruleForm.assignTimeRange[0]
            : false,
          this.ruleForm.assignTimeRange
            ? this.ruleForm.assignTimeRange[1]
            : false
        )
      ) {
        return true;
      } else {
        this.$message.warning(
          "Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes"
        );
        return false;
      }
    }
    this.$message.warning(
      "Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes"
    );
    return false;
  }
  private dwGetTicketListReqParamsNeed() {
    if (
      this.ruleForm.ticketId ||
      this.ruleForm.orderId ||
      this.ruleForm.caseId ||
      this.ruleForm.itemId
    ) {
      return true;
    } else {
      this.isGetTicketListExcelActionDone = false;
      this.$message.error(
        this.$tc(
          "pls make sure you've provided one of Ticket ID/Loan ID/Case ID/Ticket category at least"
        )
      );
      return false;
    }
  }
  private dwGetExportTicketEmailCSVNeed() {
    if (
      this.ruleForm.ticketId ||
      this.ruleForm.orderId ||
      this.ruleForm.caseId ||
      this.ruleForm.itemId
    ) {
      return true;
    } else {
      this.isGetExportTicketEmailCSVDone = false;
      this.$message.error(
        this.$tc(
          "pls make sure you've provided one of Ticket ID/Loan ID/Case ID/Ticket category at least"
        )
      );
      return false;
    }
  }
  private getEmailExtraParams() {
    const form = this.ruleForm;

    return {
      AppName: this.AppName?.toString(),
      mobile: form.mobile?.toString(),
      overdueDays: form.overdueDays1
        ? `${form.overdueDays1}~${form.overdueDays2}`
        : "",
      TicketTag: form.TicketTag,
      preStatus: form.preStatus?.join(),
      isRobot: form.machineCollection || 0,
      RobotCallIntentTag: form.RobotCallIntentTag?.join() || "",
    };
  }
  // 数据导出Excel
  private getTicketListParams(options?: { forEmail?: boolean }) {
  const form = this.ruleForm;

  let arg = {
    pageIndex: this.pageIndex,
    pageSize: this.pageSize,
    prop: this.sortCondition.prop,
    order: this.sortCondition.order,
  };

  const formatRange = (range:any) =>
    range ? `${timeFormat(range[0])} - ${timeFormat(range[1])}` : "";

  const params = [
    { type: "number", key: "itemId", value: Number(form.itemId) },
    { type: "string", key: "ticketId", value: form.ticketId },
    { type: "string", key: "orderId", value: form.orderId },
    { type: "string", key: "customerId", value: form.customerId },
    { type: "string", key: "caseId", value: form.caseId },
    { type: "string", key: "status", value: form.status?.join() },
    { type: "string", key: "assignName", value: form.assignName },
    { type: "string", key: "assignUId", value: form.assignUId },

    { type: "string", key: "createTimeRange", value: formatRange(form.createTimeRange) },
    { type: "string", key: "completeTimeRange", value: formatRange(form.completeTimeRange) },
    { type: "string", key: "closeTimeRange", value: formatRange(form.closeTimeRange) },
    { type: "string", key: "assignTimeRange", value: formatRange(form.assignTimeRange) },

    { type: "number", key: "isReloan", value: form.isReloan },
    { type: "number", key: "UrgeResult", value: form.UrgeResult },
    { type: "number", key: "outsource", value: form.outsource },
    { type: "number", key: "belongCompany", value: Number(form.belongCompany) },
    { type: "number", key: "isRoll", value: Number(form.isRoll) },
    { type: "number", key: "isStage", value: Number(form.isStage) },

    { type: "string", key: "overdueReason", value: form.overdueReason },
    { type: "array", key: "roleList", value: form.roleList },
  ];

  arg = setValue(arg, params);

  // 🔥 关键：按需合并
  if (options?.forEmail) {
    Object.assign(arg, this.getEmailExtraParams());
  }

  return arg;
}
  // 数据邮件导出
  private async getExportTicketEmailCSV() {
    let _email = this.inputExportEmail;
    if (!_email) {
      this.$message.error("Please input email address");
      this.isGetExportTicketEmailCSVDone = false;
      return;
    }

    try {
      let _arg = this.getTicketListParams({ forEmail: true });
      const { getExportTicketEmailCSV }: any = await import(
        "@/request/getTicketList"
      );
      let response = await getExportTicketEmailCSV({..._arg, email: _email}, this);

      if(response) {
        let data: any = response.toObject();
        if(data.commonout && data.commonout.code == 0) {
          this.$message.success("Email sent successfully");
        } else {
          this.$message.error(data.commonout ? data.commonout.errmsg : "Failed to send email");
        }
      } else {
        this.$message.error("Failed to send email");
      }
    } catch (error) {
      this.$message.error("Failed to send email");
    } finally {
      this.isGetExportTicketEmailCSVDone = false;
    }
  }
  private async getTicketListExcel() {
    if (this.limitTimeRange()) {
      if (this.dwGetTicketListReqParamsNeed()) {
        let _arg = this.getTicketListParams();
        const { getTicketListExcel }: any = await import(
          "@/request/getTicketList"
        );
        let response = await getTicketListExcel(_arg, this);
        if (response) {
          this.isGetTicketListExcelActionDone = response.loading
            ? response.loading
            : false;
          if (response.array[3] && response.array[3].length > 0) {
            const blob = new Blob([response.array[3]], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            downloadFile(blob, response.array[2]);
          } else {
            this.isGetTicketListExcelActionDone = false;
            this.$message.error(response.array[0][1]);
          }
        } else {
          this.isGetTicketListExcelActionDone = false;
        }
      } else {
        this.isGetTicketListExcelActionDone = false;
      }
    } else {
      this.isGetTicketListExcelActionDone = false;
    }
  }
  private inputFuction(e: any, type: string) {
    switch (type) {
      case "overdueDays1":
        if (this.ruleForm.overdueDays1.length) {
          if (this.ruleForm.overdueDays1[0] == "-") {
            this.ruleForm.overdueDays1 = "-" + e.replace(/[^0-9]/g, "");
            if (this.ruleForm.overdueDays1.length > 5) {
              this.ruleForm.overdueDays1 = this.ruleForm.overdueDays1.substring(
                0,
                5
              );
            }
          } else {
            this.ruleForm.overdueDays1 = e.replace(/[^0-9]/g, "");
            if (this.ruleForm.overdueDays1.length > 4) {
              this.ruleForm.overdueDays1 = this.ruleForm.overdueDays1.substring(
                0,
                4
              );
            }
          }
        }
        break;
      case "overdueDays2":
        if (this.ruleForm.overdueDays2.length) {
          if (this.ruleForm.overdueDays2[0] == "-") {
            this.ruleForm.overdueDays2 = "-" + e.replace(/[^0-9]/g, "");
            if (this.ruleForm.overdueDays2.length > 5) {
              this.ruleForm.overdueDays2 = this.ruleForm.overdueDays2.substring(
                0,
                5
              );
            }
          } else {
            this.ruleForm.overdueDays2 = e.replace(/[^0-9]/g, "");
            if (this.ruleForm.overdueDays2.length > 4) {
              this.ruleForm.overdueDays2 = this.ruleForm.overdueDays2.substring(
                0,
                4
              );
            }
          }
        }
        break;
    }
  }
  private testOverdueday() {
    if (this.ruleForm.overdueDays1) {
      if (
        Number(this.ruleForm.overdueDays2) < Number(this.ruleForm.overdueDays1)
      ) {
        this.$message(this.$tc("dashbordDy.Pleaseentervaliddays"));
        this.isGetTicketListActionDone = false;
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
  private getTicketList() {
    if (
      this.ruleForm.ticketId ||
      this.ruleForm.orderId ||
      this.ruleForm.caseId ||
      this.ruleForm.itemId
    ) {
      if (this.testOverdueday()) {
        let request: any = new GetTicketListReq();
        request.setCommonin(setCommon());
        request.setIsnewticket(Number(this.ruleForm.isNewTicket) || 0);
        request.setItemid(Number(this.ruleForm.itemId));
        request.setTicketid(this.ruleForm.ticketId);
        request.setOrderid(this.ruleForm.orderId);
        request.setCustomerid(this.ruleForm.customerId);
        request.setCaseid(this.ruleForm.caseId);
        request.setStatus(this.ruleForm.status.join());
        request.setAssignname(this.ruleForm.assignName);
        request.setAssignuid(this.ruleForm.assignUId);
        request.setTickettag(this.ruleForm.TicketTag);
        request.setPrestatusList(this.ruleForm.preStatus.join());
        request.setTickettag(this.ruleForm.TicketTag);
        request.setIsrobot(
          this.ruleForm.machineCollection ? this.ruleForm.machineCollection : 0
        );
        request.setTickettags(
          this.ruleForm.RobotCallIntentTag
            ? this.ruleForm.RobotCallIntentTag.join()
            : ""
        );
        request.setOverdueday(
          this.ruleForm.overdueDays1
            ? this.ruleForm.overdueDays1 + "~" + this.ruleForm.overdueDays2
            : ""
        );
        request.setPagein(
          setPage(
            this.pageIndex,
            this.pageSize,
            this.sortCondition.prop,
            this.sortCondition.order
          )
        );
        request.setAppname(this.AppName.toString());
        request.setMobile(this.ruleForm.mobile.toString());
        request.setIsreloan(this.ruleForm.isReloan);
        request.setUrgeresult(Number(this.ruleForm.UrgeResult));
        request.setIsentrust(this.ruleForm.outsource);
        request.setEntrustcompany(Number(this.ruleForm.belongCompany));
        request.setRoleidsList(this.ruleForm.roleList);
        request.setIsroll(this.ruleForm.isRoll);
        request.setIsstage(Number(this.ruleForm.isStage));
        request.setOverduereasonList(this.ruleForm.overdueReason);
        if (this.ruleForm.createTimeRange && this.ruleForm.createTimeRange[0]) {
          request.setCreatetimerange(
            timeFormat(this.ruleForm.createTimeRange[0]) +
              " - " +
              timeFormat(this.ruleForm.createTimeRange[1])
          );
        }
        if (
          this.ruleForm.completeTimeRange &&
          this.ruleForm.completeTimeRange[0]
        ) {
          request.setCompletetimerange(
            timeFormat(this.ruleForm.completeTimeRange[0]) +
              " - " +
              timeFormat(this.ruleForm.completeTimeRange[1])
          );
        }
        if (this.ruleForm.closeTimeRange && this.ruleForm.closeTimeRange[0]) {
          request.setClosetimerange(
            timeFormat(this.ruleForm.closeTimeRange[0]) +
              " - " +
              timeFormat(this.ruleForm.closeTimeRange[1])
          );
        }
        if (this.ruleForm.assignTimeRange && this.ruleForm.assignTimeRange[0]) {
          request.setAssigntimerange(
            timeFormat(this.ruleForm.assignTimeRange[0]) +
              " - " +
              timeFormat(this.ruleForm.assignTimeRange[1])
          );
        }
        ticketClient.getTicketList(request, {}, (err: any, response: any) => {
          if (response) {
            let data: any = response.toObject();
            let _fuc = this.getTicketListFuc;
            handleResponse(data, _fuc);
          }
          if (err) {
            errorMsg(err);
          }
          this.isGetTicketListActionDone = false;
        });
      }
    } else {
      this.isGetTicketListActionDone = false;
      this.$message.error(
        this.$tc(
          "pls make sure you've provided one of Ticket ID/Loan ID/Case ID/Ticket category at least"
        )
      );
    }
  }
  private getTicketListParamFuc(data: any) {
    this.ticketStatusOptions = data.ticketstatusList;
    this.ticketTypeOptions = data.ticketitemList;
    this.UrgeResultOptions = data.urgeresultmapMap;
    this.overdueReasonOptions = data.notrepayreasonmapMap;
    this.belongCompanyOptions = data.entrustcompanymapList;
    this.TicketTagMapOptions = data.tickettagmapMap;
    this.preStatusOptions = data.prestatusmapMap;
    this.RobotCallIntentTagMap = data.robotcallintenttagmapMap;
    let AppOpnList=JSON.parse(data.applist)
     Object.keys(AppOpnList).forEach((item:any) => {
       this.AppOpnList.push({
         codeName: AppOpnList[item], code: null, channel: item
       })
     });
  }
  private getTicketListParam() {
    let request: any = new GetTicketListParamReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketListParam(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.getTicketListParamFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private searchUserFuc(data: any) {
    if (data.userinfosList) {
      this.userPagerCount = data.pageout.total;
      this.userData = data.userinfosList;
      this.searchUserIds = [];
      this.userData.forEach((item: any) => {
        this.searchUserIds.push(item.id);
      });
      this.batchGetLoginInfo();
    }
  }
  private searchUser() {
    let searchRequest: any = new SearchUserReq();
    searchRequest.setCommonin(setCommon());
    searchRequest.setName(this.userForm.name);
    searchRequest.setEmail(this.userForm.email);
    searchRequest.setUsergroup(this.userForm.role);
    searchRequest.setIsattendance(this.userForm.radio);
    searchRequest.setPagein(setPage(this.userPageIndex, this.pageSize));
    searchRequest.setTicketitemid(this.ruleForm.itemId);
    client.searchUser(searchRequest, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.searchUserFuc;
        handleResponse(data, _fuc);
        if (data.commonout.code == 102) {
          this.pagerCount = 0;
          this.userData = [];
        }
      }
      if (err) {
        errorMsg(err);
      }
      this.isSearchUserActionDone = false;
    });
  }
  private batchAssignTicketFuc(data: any) {
    this.showDialogType = 0;
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  private batchAssignTicket() {
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    });
    let request: any = new BatchAssignTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.ruleForm.itemId);
    request.setAssignuid(this.selectedAssignUser.id);
    request.setTicketidsList(arr);
    ticketClient.batchAssignTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchAssignTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private batchRecycleTicketFuc(data: any) {
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  private batchRecycleTicket() {
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    });
    let request: any = new BatchRecycleTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.ruleForm.itemId);
    request.setTicketidsList(arr);
    ticketClient.batchRecycleTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchRecycleTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private batchRecallTicketFuc(data: any) {
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  private batchReccallTicket() {
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    });
    let request: any = new BatchRecallTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.ruleForm.itemId);
    request.setTicketidsList(arr);
    ticketClient.batchRecallTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchRecallTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private batchEntrustTicketFuc(data: any) {
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
    this.closeDialog();
    this.getTicketListAction();
  }
  private batchEntrustTicket() {
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    });
    let request: any = new BatchEntrustTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.ruleForm.itemId);
    request.setTicketidsList(arr);
    request.setEntrustcompany(Number(this.companyValue));
    ticketClient.batchEntrustTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchEntrustTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private rollApplyTicketFuc(data: any) {
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  private rollApplyTicket() {
    let request: any = new RollApplyTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.ruleForm.itemId);
    request.setTicketidsList(this.selectedTicketIds);
    ticketClient.rollApplyTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.rollApplyTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private reduceTicketFuc(data: any) {
    this.showTimesTips = {
      showlefttotaltips: data.showlefttotaltips,
      lefttotalgroup: data.lefttotalgroup,
      lefttotalstaff: data.lefttotalstaff,
      showleftapplyamounttips: data.showleftapplyamounttips,
      leftapplyamount: data.leftapplyamount,
    };

    if (this.showDialogType === 2) {
      this.isUseAmountRemained = data.amountremained == 0 ? false : true;
      this.amountremained = data.amountremained < 0 ? 0 : data.amountremained;
      this.leftamount = data.amount - data.amountpayed - data.amountreduced;
      this.principalData = [
        {
          label1: this.$t("ticket.DueDate"),
          value1: timeFormat(data.shouldrepaydate),
          label2: this.$t("ticket.ActualPaymentDate"),
          value2: timeFormat(data.actuallyrepaydate),
          label3: this.$t("ticket.RemissionDay"),
          value3: timeFormat(data.latestreducedate),
        },
        {
          label1: this.$t("ticket.Principal"),
          value1: data.amount,
          label2: this.$t("ticket.ActualRepaymentPrincipal"),
          value2: data.amountpayed,
          label3: this.$t("ticket.ReferralDirector"),
          value3: data.amountreduced,
          label4: this.$t("ticket.TheRemainingPrincipalCanBeReduced"),
          value4: this.isUseAmountRemained
            ? this.amountremained
            : this.leftamount,
        },
      ];
      if (data.showleftpercenttips) {
        this.principalData.push({
          label1: this.$t("ticketFhb.IndividualDeductibleAmount"),
          value1: data.leftamounttotalstaff,
          label2: this.$t("ticketFhb.GroupDeductibleAmount"),
          value2: data.leftamounttotalgroup,
        });
      }
    } else if (this.showDialogType === 3) {
      this.penaltyData = [
        {
          label1: this.$t("ticket.GracePeriodInterest"),
          value1: data.graceperiodinterest,
          label2: this.$t("ticket.ActualInterestPaidDuringGracePeriod"),
          value2: data.graceperiodinterestpayed,
          label3: this.$t("ticket.GracePeriodInterestRemissiond"),
          value3: data.graceperiodinterestreduced,
          label4: this.$t(
            "ticket.RemainingDeductibleInterestFromTheGracePeriod"
          ),
          value4: data.graceperiodinterest - data.graceperiodinterestpayed,
        },
        {
          label1: this.$t("ticket.PenaltyAndExtraFeesThatShouldBePaid"),
          value1: data.penalty,
          label2: this.$t("ticket.PenaltyInterestActuallyPaid"),
          value2: data.penaltypayed,
          label3: this.$t("ticket.RemissiondPenaltyInterest"),
          value3: data.penaltyreduced,
          label4: this.$t("ticket.TheRemainingPenaltyInterestCanBeRemission"),
          value4: data.penalty - data.penaltypayed - data.penaltyreduced,
        },
      ];
    }
  }
  private reduceTicket(row: any) {
    let request: any = new ReduceTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(Number(row.itemid));
    request.setTicketid(Number(row.id));
    request.setOrderid(row.orderid);
    ticketClient.reduceTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        this.XJoederid = row.orderid;
        let _fuc = this.reduceTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private doReduceTicketFuc() {
    if (this.showDialogType === 2) {
      this.resetForm("principalForm");
    } else if (this.showDialogType === 3) {
      this.resetForm("penaltyForm");
    }
    this.showDialogType = 0;
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }

  private async doReducePrincipal() {
    if (this.isUseAmountRemained) {
      if (this.amountremained >= this.principalForm.principal) {
        this.principalDone = true;
        let _arg: any = {
          TicketId: Number(this.isEditTicketId),
          ItemId: Number(this.isEditRow.itemid),
          ReductionAmount: Number(this.principalForm.principal),
          Reason: this.principalForm.reason,
          orderid: this.XJoederid,
        };
        const {
          getReducePrincipalReq,
          getReducePrincipalRequest,
        }: any = await import("@/request/reducePrincipalAndOther");
        let res = await getReducePrincipalRequest.handleHttp(
          getReducePrincipalReq(_arg),
          this
        );
        if (res && res.right) {
          this.principalDone = false;
          this.doReduceTicketFuc();
        } else {
          this.principalDone = false;
        }
      } else {
        let _text = this.$tc("OrderStatus.beyondCompareSubmitFailed");
        this.$message({
          type: "error",
          message: _text,
        });
      }
    } else {
      if (this.leftamount >= this.principalForm.principal) {
        this.principalDone = true;
        let _arg: any = {
          TicketId: Number(this.isEditTicketId),
          ItemId: Number(this.isEditRow.itemid),
          ReductionAmount: Number(this.principalForm.principal),
          Reason: this.principalForm.reason,
        };
        const {
          getReducePrincipalReq,
          getReducePrincipalRequest,
        }: any = await import("@/request/reducePrincipalAndOther");
        let res = await getReducePrincipalRequest.handleHttp(
          getReducePrincipalReq(_arg),
          this
        );
        if (res && res.right) {
          this.principalDone = false;
          this.doReduceTicketFuc();
        } else {
          this.principalDone = false;
        }
      } else {
        let _text = this.$tc("OrderStatus.beyondCompareSubmitFailed");
        this.$message({
          type: "error",
          message: _text,
        });
      }
    }
  }
}
